import wixWindow from 'wix-window';
import { session } from 'wix-storage';
import { filtersMenu } from 'public/filtersMenu.js'
import { showTags } from 'public/helpers.js'
import wixLocation from 'wix-location';
import wixAnimations from 'wix-animations';
import { formFactor } from 'wix-window';
import { checkSitesLive } from 'backend/checkSites.jsw'

$w.onReady(async function () {

    // checkSitesLive();

    tempStickyBugFix();
    // Sets the number of items in each repeater based on the width of the viewport
    setNumberOfItems();

    //function that gives functionality for opening and closing of filter menu
    filtersMenu('home');

    filtersMenuTags();

    seeMorefunctionallity();

    allTagsHover();

});

function tempStickyBugFix() {
    console.log('formFactor:', formFactor);
    if (formFactor === 'Mobile') {
        wixAnimations.timeline().add($w('#filtersSection'), { y: -20, duration: 0 }).play();
    }
}

// //======================
// //      Repeaters 
// //======================

export function repeater1_itemReady($item, itemData) {
    const tagsWrappers = $item('#rep01TopTagsBox').children.concat($item('#rep01BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function repeater2_itemReady($item, itemData, index) {
    const tagsWrappers = $item('#rep02TopTagsBox').children.concat($item('#rep02BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function repeater3_itemReady($item, itemData, index) {
    const tagsWrappers = $item('#rep03TopTagsBox').children.concat($item('#rep03BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function divider1Dataset_ready() {

    let itemData = $w('#divider1Dataset').getCurrentItem();
    const tagsWrappers = $w('#divider01TopTagsBox').children.concat($w('#divider01BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function divider2Dataset_ready() {
    let itemData = $w('#divider2Dataset').getCurrentItem();
    const tagsWrappers = $w('#divider02TopTagsBox').children.concat($w('#divider02BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function hero01Dataset_ready() {
    let itemData = $w('#hero01Dataset').getCurrentItem();
    const tagsWrappers = $w('#hero01TopTagsBox').children.concat($w('#hero01BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

export function hero02Dataset_ready() {
    let itemData = $w('#hero02Dataset').getCurrentItem();
    const tagsWrappers = $w('#hero02TopTagsBox').children.concat($w('#hero02BottomTagsBox').children);
    const allTagsInfo = itemData.allTagsInfo;
    showTags(allTagsInfo, tagsWrappers);
}

//Sets the number of items in each repeater based on the width of the viewport

function setNumberOfItems() {

    wixWindow.getBoundingRect()
        .then((windowSizeInfo) => {

            let windowWidth = windowSizeInfo.window.width;

            if (windowWidth < 1001 && windowWidth > 750) {
                $w('#repeater2Dataset, #repeater3Dataset').setPageSize(6);
            }

            if (windowWidth <= 750) {
                $w('#repeater1Dataset, #repeater2Dataset, #repeater3Dataset').setPageSize(3);
            }
        });

}

let clickedArray = [];

function filtersMenuTags() {
    let layouterFilterMenuTags = [...$w('#tagsBox01').children, ...$w('#tagsBox02').children]
    checkClickedArray();
    layouterFilterMenuTags.forEach((item) => {

        let itemText = item.children[0].text;

        // item.children[0].html = `<span style='color:#ababab;font-size:16px;font-family:madefor-display'>${itemText}</span>`

        item.onClick((event) => {
            wixWindow.getBoundingRect()
                .then((windowSizeInfo) => {

                    let windowWidth = windowSizeInfo.window.width;

                    let fontSize = (windowWidth < 751) ? 14 : 16;

                    let indexofItem = clickedArray.indexOf(itemText);
                    if (indexofItem === -1) {
                        item.children[0].html = `<span style='color:#ffffff;font-size:${fontSize}px;font-family:madefor-display-bold'>${itemText}</span>`
                        clickedArray.push(itemText);

                    } else {
                        item.children[0].html = `<span style='color:#ababab;font-size:${fontSize}px;font-family:madefor-display'>${itemText}</span>`
                        clickedArray.splice(indexofItem, 1);
                    }
                    checkClickedArray();
                });

        })
    })

    $w('#clearFiltersBtn').onClick(() => {
        clickedArray = [];
        layouterFilterMenuTags.forEach((item) => {
            let itemText = item.children[0].text;
            item.children[0].html = `<span style='color:#ababab;font-size:16px;font-family:madefor-display'>${itemText}</span>`
        })

        checkClickedArray()

    });

    $w('#filterBtn').onClick(() => {

        session.setItem("filterArray", JSON.stringify(clickedArray));
        wixLocation.to('/website-filters');
    })

    function checkClickedArray() {

        clickedArray.length > 0 ? $w('#filterBtn').enable() : $w('#filterBtn').disable();
    }

}

function seeMorefunctionallity() {

    $w('#repeater3Dataset').onReady(() => {
        let seeMoreCounter = 1;
        let numOfDatasetPages = $w('#repeater3Dataset').getTotalPageCount();

        if (seeMoreCounter === numOfDatasetPages) {
            $w('#seeMoreSection').collapse();
        }

        $w('#seeMoreBtn').onClick(() => {
            seeMoreCounter++;

            if (seeMoreCounter === numOfDatasetPages) {
                $w('#seeMoreSection').collapse();
            }
        })
    })

}

function allTagsHover() {
    let allTags = [...$w('#allTagsLayouter01').children, ...$w('#allTagsLayouter02').children]
    allTags.forEach((tag) => {
        let timeline = wixAnimations.timeline().add(tag, { opacity: 0.8, duration: 200 })

        tag.onMouseIn(() => {
            timeline.play();
        });

        tag.onMouseOut(() => {
            timeline.reverse();
        })
    })
}